module.exports = __webpack_public_path__ + "media/images/iconUp__errorRed--dark-1a568da28a0ca8434c7bbcb91e34f13f.png";